module.exports = __webpack_public_path__ + "media/images/about-banner-cd1290da53d854c2bdb80477a894757a.jpg";